import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  SAButton,
  SAIcon,
  SAIcons,
  SAIconSize,
  SAPopover,
  SASelect,
  SATabBar,
} from "@saux/design-system-react";
import Button from "@mui/material/Button";
import "./AutomatedMessagesTemplate.css"
import { Add, MessageSharp, Remove } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import { loader } from "graphql.macro";
import send_message_icon from "../../icons/SendMessage.png";
import error_img from "../../icons/Error.png";
import success from "../../icons/Success.png";
import trash_icon from "../../icons/TrashCan.svg";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { simpleGTMDataLayer, sortByDate } from "../../utils/utilities";
import { Modal } from "../../styles/Modal.style";
import { SATextField } from "../TextField/TextField";
import { Grid, Hidden, Typography } from "@material-ui/core";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { CUSTOMER, SNACKBAR } from "../../utils/constants";

import CircularProgress from "@material-ui/core/CircularProgress";

import { executeGraphqlMutation, executeGraphqlQuery } from "../../graphql/api";
import { createTrue } from "typescript";
import claimSearch from "../../store/actions/claimsSearchActions";
import pinIcon from '../../icons/PinIcon.png';
import { MESSAGES_LOADER } from "../../store/action-types/loaderActionTypes";
const getTemplateMessages = loader(
  "../../graphql/queries/getTemplateMessages.graphql"
);

const deleteMessage = loader("../../graphql/mutations/deleteMessage.graphql");

const createMessage = loader(
  "../../graphql/mutations/createTemplateMessage.graphql"
);

const updateTemplateMessage = loader(
  "../../graphql/mutations/updatePinMessage.graphql"
);

const TabBar = styled(SATabBar)` 
  li button{
    cursor: pointer !important;
  }
  li {
    margin: 0;
    width: 50% !important;
  }
`;
const Template = styled.div`
  width: 32rem;
  @media (max-width: 768px) {
    width: 20rem;
  }
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  margin: 80px auto;
  .template-header {
    display: flex;
  }
  .message-category {
    margin-top: 20px;
    .heading {
      font-size: 16px;
      font-family:Lato !important;
    }
    .automated-message {
      display: flex;
      margin-top: 10px;
      img {
        cursor: pointer;
      }
      .text {
        font-size: 12px;
        margin: auto 12px;
        font-family:Lato;
      }
    }
  }
`;

const WhiteAddIcon = withStyles({
  root: {
    fill: "#FFFFFF",
    height: "32px",
    width: "32px",
    position: "relative",
    left: "18%",
    top: "18%",
  },
})(Add);

const ButtonText = withStyles((theme) => ({
  body1: {
    fontSize: 16,
    fontFamily: "Lato",
    fontWeight: "bold",
    color: "white",
    [theme.breakpoints.up("md")]: {
      fontSize: 18,
      fontFamily: "Lato"
    },
  },
  body2: {
    fontSize: 16,
    fontFamily: "Lato",
    fontWeight: "bold",
    lineHeight: "19px",
    color: "#ED323B",
    [theme.breakpoints.up("md")]: {
      fontSize: 18,
      fontFamily: "Lato"
    },
  },
}))(Typography);

const ImageModal = styled(Modal)`
  height: 100vh;
`;

const MessageTab = styled.div`
  overflow-y: auto;
  height: 25em;
`;

const TextMessageTab = styled.div`
  height: 25em;
`;

const UnderLine = styled.div`
  border: 1px solid black;
  margin-top: 5px;
`;
const LoaderModal = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
`;
const DynamicButton = styled.div`
  margin-top: 0.3em;
  height: 50.000003814697266px;
  width: 50px;
  left: 0px;
  top: 0px;
  border-radius: 5px;
  padding: 13px, 25px, 13px, 25px;
  margin-left: auto;
  cursor: pointer;
  background-color: #0173c6;
`;

interface IPersonalMessage {
  templateId: string;
  message: string;
  pinStatus: boolean;
  title: string;
}

interface ICurrentDynamicContent {
  label: string;
  value: string;
}

export default function AutomatedMessagesTemplate(props: any) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [referenceElement, setReferenceElement] = useState<Element | null>(
    null
  );
  const [selectedMessage, setSelectedMessage] = useState<any>({});
  const [lossDate, setLossDate] = useState("");
  const inputRef: React.MutableRefObject<HTMLInputElement | null> = React.useRef<HTMLInputElement | null>(null);
  const selectedConversation = useSelector(
    (state: any) => state.chat.selectedConversation
  );
  // const selectedconvParticipants = useSelector(
  //   (state: any) => state.chat.participants[selectedConversation.conversationId]
  // );
  const customer = useSelector(
    (state: any) => state.chat.customer
  );
  const dynamicContent = {
    customerFirstName: customer?.firstName,
    customerLastName: customer?.lastName,
    customerPhoneNumber: customer?.mobileNumber,
    claimNumber: selectedConversation?.claimNumber,
    lossDate: customer?.lossDate
  };
  const [loader, setLoader] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState({
    flag: false,
    id: "",
    message: "",
    title:null
  });
  const [saveFlag, setSaveFlag] = useState(false);
  const [createFlag, setCreateFlag] = useState(false);
  const [newMsg, setNewMsg] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [addFlag, setAddFlag] = useState([
    { label: "claim no", isAdd: true },
    { label: "contact's first name", isAdd: true },
    { label: "contact's last name", isAdd: true },
    { label: "contact's mobile no.", isAdd: true },
    { label: "loss date", isAdd: true },

  ]);
  const itemLabels = [
    "Default Templates",
    "Personal Templates",
    "Create Templates",
  ];
  const dynamicDDOptions = [
    { label: "claim no", value: "<ClaimNumber>" },
    {
      label: "contact's first name",
      value: "<ContactFirstName>",
    },
    { label: "contact's last name", value: "<ContactLastName>" },
    {
      label: "contact's mobile no.",
      value: "<ContactMobileNumber>",
    },
    {
      label: "loss date",
      value: "<LossDate>",
    },
  ];

  const dynamicMsgControl = [
    { value: dynamicContent.claimNumber, label: "<ClaimNumber>" },
    {
      value: dynamicContent.customerFirstName,
      label: "<ContactFirstName>",
    },
    { value: dynamicContent.customerLastName, label: "<ContactLastName>" },
    {
      value: dynamicContent.customerPhoneNumber,
      label: "<ContactMobileNumber>",
    },
    {
      value: dynamicContent.lossDate,
      label: "<LossDate>",
    },
  ];

  const [personalMsg, setPersonalMsg] = useState<IPersonalMessage[]>();
  const [submitFlag, SetsubmitFlag] = useState(false);
  const [dynamicCharCount, setDynamicCharCount] = useState(0);
  const [currDDContent, setCurrDDContent] = useState<ICurrentDynamicContent>({
    label: "claim no",
    value: "<ClaimNumber>",
  });
  const addDynamicContent = () => {
    const addFlagNew = addFlag.filter(
      (obj) => obj.label != currDDContent.label
    );
    const start: any = inputRef.current?.selectionStart;
    const end: any = inputRef.current?.selectionEnd;
    const value: any = newMsg;

    setAddFlag([...addFlagNew, { label: currDDContent.label, isAdd: false }]);
    setNewMsg(value.slice(0, start) + currDDContent.value + value.slice(end));
    if (inputRef !== null) {
      inputRef.current!.selectionStart = inputRef.current!.selectionEnd = start + currDDContent.value.length;
    }
    //setNewMsg(newMsg + " " + currDDContent.value);
    setDynamicCharCount(newMsg.length + currDDContent.value.length + 1);
  };


  const dispatch = useDispatch();

  const handleChange = (e: any) => {
    const [label, value] = [
      getLabelByValue(dynamicDDOptions, e.target.value),
      e.target.value,
    ];

    setCurrDDContent({ ...currDDContent, label: label, value: value });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Dropdown-Option-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Select ${label} from dynamic content.`,
      event_value: `${user.fullName} selected ${label} from dynamic content dropdown option list.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Dropdown-Option-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Select ${label} from dynamic content.`,
      event_value: `${user.fullName} selected ${label} from dynamic content dropdown option list.`
    });
  };

  const handleMessage = (e: any) => {
    setNewMsg(e.target.value);
  };

  const handleTitle = (e: any) => {
    setTitle(e.target.value);
  };


  const getDynamicMessage = (msg: string) => {
    const message = dynamicMsgControl.reduce(
      (previousValue, currentValue) =>
        previousValue.replaceAll(currentValue.label, currentValue.value),
      msg
    );
    return message;
  };

  const getLabelByValue = (arryObject: any, value: string) => {
    return arryObject.find((obj: any) => obj.value == value).label;
  };

  const getFlagByLabel = (arryObject: any, label: string) => {
    return arryObject?.find((obj: any) => obj.label == label).isAdd;
  };

  const saveMessage = () => {
    let titleVal = title === '' ? null : title;
    newMsg != "" &&
      executeGraphqlMutation(createMessage, {
        adjusterId: user.email,
        message: newMsg,
        title: titleVal
      })
        .then((res: any) => {
          if (res.data.createMessageTemplate.status == "Success") {
            setSaveFlag(false);
            setCreateFlag(true);
            getMessages();
            setNewMsg("");
            setTitle("");
            setAddFlag([
              { label: "claim no", isAdd: true },
              { label: "contact's first name", isAdd: true },
              { label: "contact's last name", isAdd: true },
              { label: "contact's mobile no.", isAdd: true },
              { label: "loss date", isAdd: true },
            ]);
          } else {
            throw Error;
          }
        })
        .catch((error) => {
          console.log(error);
          setSaveFlag(false);
          setNewMsg("");
          setTitle("");
          dispatch(
            snackbarOpen({
              open: true,
              message: "something went wrong",
              type: SNACKBAR.ERROR,
            })
          );
        });
  };

  const removeMessage = (id: string) => {
    setLoader(true);
    executeGraphqlMutation(deleteMessage, {
      adjusterId: user.email,
      templateId: id,
    })
      .then((res: any) => {
        if (res.data.deleteMessageTemplate.status == "Success") {
          setLoader(false);
          setDeleteFlag({
            flag: false,
            id: "",
            message: "",
            title:null
          });
          dispatch(
            snackbarOpen({
              open: true,
              message: "Personal Template Deleted",
              type: SNACKBAR.SUCCESS,
            })
          );
          getMessages();
          simpleGTMDataLayer({
            csrId: user.userName,
            event: `Delete-Template-Message-Click`,
            event_action: "Button Click",
            event_category: window.location.pathname,
            event_label: `Making template message delete`,
            event_value: `${user.fullName} deleted template message with claim number ${selectedConversation.claimNumber}.`,
            claim_number: selectedConversation.claimNumber,
          });
          simpleGTMDataLayer({
            csrId: user.userName,
            event: `Delete-Template-Message-Click-Snowplow`,
            event_action: "Button Click",
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Making template message delete`,
            event_value: `${user.fullName} deleted template message with claim number ${selectedConversation.claimNumber}.`,
            claim_number: selectedConversation.claimNumber,
          });
        } else {
          throw Error;
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
        dispatch(
          snackbarOpen({
            open: true,
            message: "something went wrong",
            type: SNACKBAR.ERROR,
          })
        );
      });
  };

  const tabChange = (newActiveIndex: number) => {
    setActiveIndex(newActiveIndex);
    setCurrDDContent({
      label: "claim no",
      value: "<ClaimNumber>",
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Message-Template-Tab-Click`,
      event_action: "Button Click",
      event_category: window.location.pathname,
      event_label: `${itemLabels[newActiveIndex]} tab click`,
      event_value: `${user.fullName} clicked ${itemLabels[newActiveIndex]} tab.`,
      //claim_number: selectedConversation.claimNumber,
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Message-Template-Tab-Click-Snowplow`,
      event_action: "Button Click",
      event_category: window.location.pathname + "/Snowplow",
      event_label: `${itemLabels[newActiveIndex]} tab click`,
      event_value: `${user.fullName} clicked ${itemLabels[newActiveIndex]} tab.`,
      //claim_number: selectedConversation.claimNumber,
    });
  };

  const user = useSelector((state: any) => state.user);

  useEffect(() => {
    props.messageUpload();
  }, [props.newMessage]);

  const sortTemplateMessages = (templates: any[]) => {
    const upinnmessages = (templates || []).filter(
      (msg: any) => msg.pinStatus !== true
    );
    const sortedMsgs: any[] = sortByDate(upinnmessages, "desc");
    return sortedMsgs;
  }

  const getMessages = () => {
    setLoader(true);
    executeGraphqlQuery(getTemplateMessages, {
      adjusterId: user.email,
    })
      .then((res: any) => {
        if (res.data.getCustomMessageTemplates.templates[0]) {
          const pinnedMessages = getPinnedTemplateMessages(res.data.getCustomMessageTemplates.templates);
          const sortMessages = sortTemplateMessages(res.data.getCustomMessageTemplates.templates);
          const updateMessages = [...pinnedMessages, ...sortMessages];
          setPersonalMsg(updateMessages);
          setLoader(false);
        }
        else {
          setPersonalMsg([]);
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        dispatch(
          snackbarOpen({
            open: true,
            message: "Error occured while retrieving personal message template",
            type: SNACKBAR.ERROR,
          })
        );
      });
  };

  // useLayoutEffect(() => {
  //   setLoader(true);
  //   claimSearch({ query: selectedConversation.claimNumber })
  //     .then((res: any) => {
  //       setLoader(false);
  //       setLossDate(
  //         res.data.searchClaims.find(
  //           (obj: any) => obj.claim_number == selectedConversation.claimNumber
  //         ).loss_date
  //       );
  //     })
  //     .catch((err) => {
  //       setLoader(false);
  //       console.log(err);
  //     });
  // }, []);

  useEffect(getMessages, []);

  const modalOnClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const messages = [
    `Hi, this is ${user.fullName} I'm here to help you with your claim ${selectedConversation.claimNumber}.`,
    `You can reach me at ${user.profileInfo?.workPhoneNumber} or ${user.email
    } ${user.profileInfo?.startTime && user.profileInfo?.endTime
      ? `between ${user.profileInfo?.startTime} and ${user.profileInfo?.endTime} ${user.profileInfo?.timeZone}`
      : ""
    }`,
    `You can review your claim at https://myclaimshub.stateauto.com/login-flow`,
    `we have created a rental reservation at Enterprise Rent-A-Car, thier phone number is ${user.profileInfo?.workPhoneNumber} your reservation number is ${user.profileInfo?.workPhoneNumber}`,
  ];

  const sendMessage = (message: string, activeIndex: number) => {
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Automated-Message-Click`,
      event_action: "Button Click",
      event_category: window.location.pathname,
      event_label: `${itemLabels[activeIndex]} : Sending template message in a conversation.`,
      // event_value: `${user.fullName} triggered automated message "${getDynamicMessage(message)}" in a conversation with claim number ${selectedConversation.claimNumber}.`,
      event_value: getDynamicMessage(message),
      claim_number: selectedConversation.claimNumber,
    });

    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Automated-Message-Click-Snowplow`,
      event_action: "Button Click",
      event_category: window.location.pathname + "/Snowplow",
      event_label: `${itemLabels[activeIndex]} : Sending template message in a conversation.`,
      //event_value: `${user.fullName} triggered automated message "${getDynamicMessage(message)}" in a conversation with claim number ${selectedConversation.claimNumber}.`,
      event_value: getDynamicMessage(message),
      claim_number: selectedConversation.claimNumber,
    });
    props.setNewMessage(getDynamicMessage(message));
  };

  const getPinnedTemplateMessages = (PersonalMsgs: any) => {
    const pinnedPersonalMessages = (PersonalMsgs || []).filter(
      (msg: any) => msg.pinStatus
    );
    return pinnedPersonalMessages;
  }

  const handleClose = (
    event: React.MouseEvent<HTMLElement> | MouseEvent,
    index: number | null
  ) => {
    setReferenceElement(null);
    if (index === 1) {
      if (
        getPinnedTemplateMessages(personalMsg).length >= 3 &&
        !selectedMessage.pinStatus
      ) {
        dispatch(
          snackbarOpen({
            open: true,
            message:
              "3 pin template messages limit, to pin this template, unpin another one first",
            type: SNACKBAR.ERROR,
          })
        );
        return;
      }
      executeGraphqlQuery(updateTemplateMessage, {
        adjusterId: user.email,
        templateId: selectedMessage.templateId,
        pin: !selectedMessage.pinStatus
      })
        .then((res: any) => {
          if (res.data.pinMessageTemplate.status == "Success") {
            getMessages();


            let label = selectedMessage.pinStatus ? "Unpin" : "Pin";
            simpleGTMDataLayer({
              csrId: user.userName,
              event: `${label}ned-Template-Message-Click`,
              event_action: "Menu option Click",
              event_category: window.location.pathname,
              event_label: `${label}ning a template message`,
              event_value: `${user.fullName} ${label}ned template message with claim number ${selectedConversation.claimNumber}.`,
              claim_number: selectedConversation.claimNumber,
            });
            simpleGTMDataLayer({
              csrId: user.userName,
              event: `${label}ned-Template-Message-Click-Snowplow`,
              event_action: "Menu option Click",
              event_category: window.location.pathname + "/Snowplow",
              event_label: `${label}ning a template message`,
              event_value: `${user.fullName} ${label}ned template message with claim number ${selectedConversation.claimNumber}.`,
              claim_number: selectedConversation.claimNumber,
            });
          }
          else {
            throw Error;
          }
        })
    } else if (index === 0) {
      setDeleteFlag({
        flag: true,
        id: selectedMessage.templateId,
        message: selectedMessage.message,
        title:selectedMessage.title
      })
    }

  }


  const handleMenuOptions = (event: React.MouseEvent<HTMLElement>) => {
    setReferenceElement(event.currentTarget);
  }

  return (
    <>
      {loader && (
        <LoaderModal>
          <Grid container alignItems="center" style={{ height: "80vh" }}>
            <Grid
              container
              justify="flex-end"
              direction="row"
              alignItems="center"
            >
              <Grid item xs={12}>
                <div className="loader" />
              </Grid>
            </Grid>
          </Grid>
        </LoaderModal>
      )}

      <ImageModal
        data-testid="automated-message-modal"
        onClickHandler={(event: React.MouseEvent) => modalOnClickHandler(event)}
      >
        <Template>
          <div className="template-header">
            <div style={{ fontWeight: "bold", fontSize: 20, fontFamily: "Lato" }}>
              Message Templates
            </div>
            <div
              style={{ marginLeft: "auto", cursor: "pointer" }}
              data-testid="close"
              onClick={() => props.setDialogOpen(false)}
            >
              <SAIcon
                icon={SAIcons.x}
                colorVariant={"#666666"}
                size={SAIconSize.small}
              ></SAIcon>
            </div>
          </div>
          <br />
          <TabBar
            activeIndex={activeIndex}
            itemLabels={itemLabels}
            onChange={tabChange}
          />
          {activeIndex === 0 && (
            <MessageTab>
              <div className="message-category">
                <div className="heading">Greetings</div>
                <UnderLine />
                <div
                  className="automated-message"
                  data-testid="greetings"
                  onClick={() => sendMessage(messages[0],activeIndex)}
                >
                  <img
                    src={send_message_icon}
                    alt="#"
                    width={32}
                    height={32}
                  ></img>
                  <div className="text">{messages[0]}</div>
                </div>
              </div>

              <div className="message-category">
                <div className="heading">Personal Information</div>
                <UnderLine />
                <div
                  className="automated-message"
                  data-testid="personal-info"
                  onClick={() => sendMessage(messages[1],activeIndex)}
                >
                  <img
                    src={send_message_icon}
                    alt="#"
                    width={32}
                    height={32}
                  ></img>
                  <div className="text">{messages[1]}</div>
                </div>
              </div>
              <div className="message-category">
                <div className="heading">Links</div>
                <UnderLine />
                <div
                  className="automated-message"
                  data-testid="links"
                  onClick={() => sendMessage(messages[2],activeIndex)}
                >
                  <img
                    src={send_message_icon}
                    alt="#"
                    width={32}
                    height={32}
                  ></img>
                  <div className="text">{messages[2]}</div>
                </div>
              </div>
            </MessageTab>
          )}
          {activeIndex === 1 && (
            <>
              {deleteFlag.flag ? (
                <MessageTab>
                  <Grid
                    container
                    spacing={3}
                    xs={12}
                    md={12}
                    justify="flex-start"
                  // style={{ padding: "30px" }}
                  >
                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>
                    <Grid item sm={12}>
                      <div style={{ color: "#ED323B", fontSize: 17, fontFamily: "Lato" }}>
                        SELECTED TEMPLATE FOR REMOVAL
                      </div>
                    </Grid>
                    {deleteFlag.title!==null &&
                    <Grid item sm={12}>
                      <div style={{ color: "#3B3B3B", fontSize: 16, fontFamily: "Lato", fontWeight:"bold" }}>
                        {deleteFlag.title}
                      </div>
                    </Grid>}

                    <Grid item sm={12}>
                      <div
                        style={{
                          fontSize: 16,
                          height: "12em",
                          fontFamily: "Lato"
                        }}
                      >
                        {getDynamicMessage(deleteFlag.message)}
                      </div>
                    </Grid>
                    <Grid item sm={6}></Grid>
                    <Grid item sm={3}>
                      <SAButton
                        color="black"
                        label="Cancel"
                        variant="link-medium"
                        onClick={() => {
                          setDeleteFlag({
                            flag: false,
                            id: "",
                            message: "",
                            title:null
                          });
                        }}
                      />
                    </Grid>

                    <Grid item sm={3}>
                      <Button
                        variant="contained"
                        style={{ backgroundColor: "red" }}
                        startIcon={<DeleteIcon />}
                        onClick={() => removeMessage(deleteFlag.id)}
                      >
                        Delete
                      </Button>
                    </Grid>
                  </Grid>
                </MessageTab>
              ) : (
                <MessageTab>
                  {personalMsg && personalMsg[0] ? (
                    personalMsg?.map((msgs) => (
                      <div className="message-category">
                        <div className="automated-message">
                          <img
                            src={send_message_icon}
                            alt="#"
                            width={32}
                            height={32}
                            onClick={() =>
                              sendMessage(getDynamicMessage(msgs.message),activeIndex)
                            }
                          ></img>
                          <div className="main-template">
                            {msgs.pinStatus === true ?
                              <div style={{ marginBottom: "8px",cursor:"default" }}>
                                <img
                                  style={{ width: 16, height: 16, marginLeft: "10px", position: "relative", top: "5px" }}
                                  src={pinIcon}
                                  alt={""}
                                />
                                <span className="pin">Pinned Template</span></div> : null}
                            {(msgs.title !== null) &&
                              <div className="title text" style={{lineHeight:"13.33px", cursor:"default", width: "35em", marginBottom: "5px" }}>

                                {msgs.title}</div>}

                            <div className="text" style={{ width: "35em", cursor:"default" }}>
                              {getDynamicMessage(msgs.message)}
                            </div>
                          </div>
                          <div className="menu-icon" data-testid="menu-icon"
                            onClick={() => { setSelectedMessage(msgs) }}>
                            <SAIcon style={{ position: "relative", top: 8 }} data-testid="menu-options" icon={SAIcons.menuKabob} size={SAIconSize.small} colorVariant="dark"
                              onClick={handleMenuOptions} />
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <>
                      <Grid
                        container
                        spacing={3}
                        xs={12}
                        md={12}
                        justify="flex-start"
                      >
                        <Hidden xsDown>
                          <Grid item sm={12} />
                        </Hidden>
                        <Hidden xsDown>
                          <Grid item sm={12} />
                        </Hidden>

                        <Hidden xsDown>
                          <Grid item sm={12} />
                        </Hidden>
                        <Hidden xsDown>
                          <Grid item sm={12} />
                        </Hidden>

                        <Hidden xsDown>
                          <Grid item sm={12} />
                        </Hidden>
                        <Hidden xsDown>
                          <Grid item sm={5} />
                        </Hidden>

                        <Grid item sm={2}>
                          <img
                            src={error_img}
                            alt="#"
                            width={56}
                            height={56}
                          ></img>
                        </Grid>
                        <Hidden xsDown>
                          <Grid item sm={5} />
                        </Hidden>

                        <Grid item sm={12}>
                          <div
                            style={{
                              fontSize: 20,
                              display: "flex",
                              justifyContent: "center",
                              fontFamily: "Lato"
                            }}
                          >
                            No personal template messages are available
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </MessageTab>
              )}
            </>
          )}
          {activeIndex === 2 && (
            <>
              {saveFlag ? (
                <MessageTab>
                  <Grid
                    container
                    spacing={3}
                    xs={12}
                    md={12}
                    justify="flex-start"
                  >
                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>
                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>

                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>
                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>

                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>
                    <Hidden xsDown>
                      <Grid item sm={5} />
                    </Hidden>

                    <Grid item sm={2}>
                      <SaveIcon
                        color={"primary"}
                        style={{ width: 60, height: 60 }}
                      />
                    </Grid>
                    <Hidden xsDown>
                      <Grid item sm={5} />
                    </Hidden>

                    <Grid item sm={12}>
                      <div
                        style={{
                          fontSize: 20,
                          display: "flex",
                          justifyContent: "center",
                          fontFamily: "Lato"
                        }}
                      >
                        Saving Personal Template Message
                      </div>
                    </Grid>

                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>

                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>

                    <Hidden xsDown>
                      <Grid item sm={8} />
                    </Hidden>
                    <Grid item sm={2}>
                      <Button
                        variant="contained"
                        style={{
                          margin: "1.3em",
                          paddingLeft: "1.3em",
                          backgroundColor: "green",
                          color: "white",
                          pointerEvents: "none",
                        }}
                      >
                        <CircularProgress
                          style={{
                            marginLeft: 0,
                            marginRight: "0.5em",
                            color: "white",
                          }}
                          size={16}
                        />
                        SAVING
                      </Button>
                    </Grid>
                  </Grid>
                </MessageTab>
              ) : createFlag ? (
                <MessageTab>
                  <Grid
                    container
                    spacing={3}
                    xs={12}
                    md={12}
                    justify="flex-start"
                  >
                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>

                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>

                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>

                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>
                    <Hidden xsDown>
                      <Grid item sm={12} />
                    </Hidden>
                    <Grid
                      item
                      sm={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <img src={success} alt="#" width={42} height={42}></img>
                    </Grid>

                    <Grid item sm={12}>
                      <div
                        style={{
                          fontSize: 20,
                          display: "flex",
                          justifyContent: "center",
                          fontFamily: "Lato"
                        }}
                      >
                        Personal Template Message Saved
                      </div>
                    </Grid>

                    <Grid
                      item
                      sm={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        startIcon={<WhiteAddIcon height={32} width={32} />}
                        onClick={() => setCreateFlag(false)}
                        size="large"
                        color="success"
                        variant="contained"
                      >
                        <ButtonText variant="body1">
                          {"CREATE NEW TEMPLATE"}
                        </ButtonText>
                      </Button>
                    </Grid>
                  </Grid>
                </MessageTab>
              ) : (
                <TextMessageTab>
                  <br />
                  <SATextField
                    label="Template Title"
                    id={`Title`}
                    InputLabelProps={{ "aria-labelledby": "title" }}
                    style={{
                      fontFamily: "Lato",
                      fontSize: "16px",
                      lineHeight: "20.8px",
                      marginBottom:"4px"
                    }}
                    onChange={handleTitle}
                    minRows={1}
                    rowsMax={1}
                    characterLimit={100}
                    value={title}
                  />
                  <label style={{ color: "#666666", paddingLeft: "15px", fontSize: "15px", fontFamily:"Lato" }}>Optional</label>
                  <SATextField
                    label="Template Message"
                    id={`TemplateMessage`}
                    InputLabelProps={{ "aria-labelledby": "templateMessage" }}
                    style={{
                      fontFamily: "Lato",
                      fontSize: "16px",
                      lineHeight: "20.8px",
                      marginTop: "15px"
                    }}
                    onChange={handleMessage}
                    multiline
                    minRows={9}
                    rowsMax={9}
                    showCharacterCount
                    afterReset={submitFlag}
                    dynamicCharCount={dynamicCharCount}
                    characterLimit={500}
                    value={newMsg}
                    inputRef={inputRef}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div style={{ marginRight: "1em" }}>
                        <SASelect
                          style={{
                            width: "13em",
                            backgroundColor: "white",
                            fontSize: "16px",
                            fontFamily: "Lato"
                          }}
                          label="Dynamic Content"
                          id="DynamicSelect"
                          onChange={handleChange}
                          options={dynamicDDOptions}
                          className="select_SA"
                        />
                      </div>

                      <DynamicButton onClick={addDynamicContent}>
                        <WhiteAddIcon height={32} width={32} />
                      </DynamicButton>

                    </div>

                    <SAButton
                      fullWidth={false}
                      label="SAVE TEMPLATE"
                      style={{
                        fontSize: "19.2px",
                        fontFamily: "Lato"
                      }}
                      onClick={() => {
                        setSaveFlag(true);
                        setTimeout(saveMessage, 2000);
                        setCurrDDContent({
                          label: "claim no",
                          value: "<ClaimNumber>",
                        });
                      }}
                      textTransform="uppercase"
                      variant="primary"
                      disabled={newMsg == ""}
                    />
                  </div>
                </TextMessageTab>
              )}
            </>
          )}
        </Template>
        <SAPopover
          data={[
            "Delete Template Message",
            selectedMessage?.pinStatus ?
              "Unpin Template Message" :
              "Pin Template Message"
          ]}
          onClose={(e: MouseEvent, index: number | null) =>
            handleClose(e, index)
          }
          placement="bottom-end"
          referenceElement={referenceElement}
          variant="popover-menu"
        />
      </ImageModal>
    </>
  );
}